import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AuthApi from "../../api/authApi";
import ChangePassword from "./ChangePassword";
import ProfileDetails from "./ProfileDetails";
import { useAuthUser } from "../../hooks/useAuthUser";

const MyProfile = (): JSX.Element => {
  const userData = useAuthUser();
  let api = new AuthApi();
  const [userProfileData, setUserProfileData] = useState<Record<string, any>>({});

  useEffect(() => {
    getProfileData();
    
  }, []);

  const getProfileData = async () => {
    await api
      .getProfile({ id: userData.id })
      .then((response: any) => {
        if (response.data) {
          setUserProfileData(response.data);
        }
      })
      .catch((error: any) => {
        toast.error(error.toString());
        console.error("There is an error!", error);
      });
  };

  return (
    <div className="settings">
      <div className="card ext-space">
        <div className="card-body">
          <p className="card-description">
            Here you can change password and emails.
          </p>
          {/* <ProfileDetails
            userProfileData={userProfileData}
            getProfileData={getProfileData}
          /> */}
          <ChangePassword
            userProfileData={userProfileData}
            getProfileData={getProfileData}
          />
        </div>
      </div>
    </div>
  );
};
export default MyProfile;
